import { useLocation, useSearchParams } from 'react-router-dom';
import type { Campaign } from '../../types/campaign';
import { CampaignForm } from './CampaignForm';

// Pre-P2b-3 polish (Fix 6): the duplicate flow on CampaignDetail
// navigates here with the source Campaign in location.state. Refresh
// loses the state (Q10 trade-off accepted) — AM gets a blank create
// form on hard refresh and can navigate back to retry.
type LocationStateShape = { duplicateFrom?: Campaign };

export function CampaignNew() {
  const [params] = useSearchParams();
  const brand = params.get('brand');
  const location = useLocation();
  const duplicateFrom = (location.state as LocationStateShape | null)?.duplicateFrom;

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-slate-900">
        {duplicateFrom ? 'Duplicate campaign' : 'New campaign'}
      </h1>
      {duplicateFrom && (
        <p className="text-sm text-slate-600">
          Pre-filled from <strong>{duplicateFrom.name}</strong>. Pick a unique slug
          and tweak as needed before saving.
        </p>
      )}
      <CampaignForm
        mode={{
          kind: 'create',
          brandAccountId: brand,
          duplicateSource: duplicateFrom,
        }}
      />
    </div>
  );
}
